@for (
    choice of visibleChoices();
    track mobile() ? 'phone-primary' : choice.id
) {
    <button
        qpxButton
        matIconButton
        [size]="mobile() ? 'sm' : 'md'"
        [context]="choice.active ? undefined : 'secondary'"
        tone="muted"
        [attr.aria-label]="choice.ariaLabel"
        [attr.aria-pressed]="choice.active"
        [attr.aria-controls]="choice.controls ?? null"
        [class]="choice.className ?? ''"
        [class.active]="choice.active"
        [disabled]="choice.disabled"
        [qpxTooltip]="choice.label"
        matTooltipPosition="below"
        (click)="choice.onSelect($event)"
    >
        <ng-icon qpx [name]="choice.icon" />
    </button>
}
@if (mobile() && otherChoices().length) {
    <button
        qpxButton
        matIconButton
        size="sm"
        context="secondary"
        tone="muted"
        [attr.aria-label]="menuLabel()"
        [matMenuTriggerFor]="paneMenu"
    >
        <ng-icon qpx name="lucideChevronDown" />
    </button>
    <mat-menu #paneMenu="matMenu" [aria-label]="menuLabel()">
        @for (choice of otherChoices(); track choice.id) {
            <button
                mat-menu-item
                [class]="choice.className ?? ''"
                [attr.aria-label]="choice.ariaLabel"
                [attr.aria-controls]="choice.controls ?? null"
                [disabled]="choice.disabled"
                (click)="choice.onSelect($event)"
            >
                <ng-icon qpx matMenuItemIcon size="sm" [name]="choice.icon" />
                <span>{{ choice.label }}</span>
            </button>
        }
    </mat-menu>
}
